import { applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { composeWithDevTools } from 'redux-devtools-extension';
import axios from 'axios';
import axiosMiddleware from 'redux-axios-middleware';

import createRootReducer from './reducers';

export const history = createBrowserHistory();

declare global {
  interface Window {
    _env_: { [k: string]: string };
  }
}

export const client = axios.create({
  baseURL: window._env_.REACT_APP_BACKEND_URL || 'http://localhost:3000',
  responseType: 'json',
});

if (!!localStorage.getItem('Authorization')) {
  client.defaults.headers.common['Authorization'] = localStorage.getItem('Authorization');
}

export const configureStore = () => {
  return createStore(
    createRootReducer(history),
    composeWithDevTools(applyMiddleware(routerMiddleware(history), axiosMiddleware(client)))
  );
};
